import { memo } from 'react';
import AnimatedHeight from 'react-animate-height';
import { useToggleState } from '@app/utils';
import { FilterOption as FilterOptionType } from '../../../../../../types';
import { FilterOption } from '../Option';

type OptionsListProps = {
  getIsChecked: (value: string) => boolean;
  isDynamic: boolean;
  onChange: (value: string, label?: string) => void;
  option: FilterOptionType;
};
export const OptionsListComponent = ({
  option,
  isDynamic,
  onChange,
  getIsChecked,
}: OptionsListProps) => {
  const [isNestedFiltersOpen, toggleNestedFiltersOpen] = useToggleState(false);

  return (
    <>
      <FilterOption
        option={option}
        isDynamic={isDynamic}
        onChange={onChange}
        isChecked={getIsChecked(option.value)}
        isNestedFiltersOpen={isNestedFiltersOpen}
        toggleNestedFiltersOpen={toggleNestedFiltersOpen}
      />
      {!!option.children?.length && (
        <AnimatedHeight height={isNestedFiltersOpen ? 'auto' : 0}>
          {isNestedFiltersOpen && (
            <ul className="list-none p-0 mt-1 ml-7">
              {option.children.map((nestedOption) => (
                <OptionsListComponent
                  key={nestedOption.value}
                  option={nestedOption}
                  isDynamic={isDynamic}
                  onChange={onChange}
                  getIsChecked={getIsChecked}
                />
              ))}
            </ul>
          )}
        </AnimatedHeight>
      )}
    </>
  );
};

export const OptionsList = memo(OptionsListComponent, (prevProps, nextProps) => {
  return (
    prevProps.option === nextProps.option &&
    prevProps.isDynamic === nextProps.isDynamic &&
    prevProps.onChange === nextProps.onChange &&
    prevProps.getIsChecked === nextProps.getIsChecked
  );
});
